// Komponenty zakładek dla różnych widoków cen

import React from "react";
import { useAccommodation } from "../../AccommodationProvider";
import { PriceViewMode } from "../../types/pricing.types";

interface TabConfig {
  mode: PriceViewMode;
  label: string;
  icon: string;
  description: string;
}

const VIEW_MODES: TabConfig[] = [
  {
    mode: "availability",
    label: "Dostępność",
    icon: "📊",
    description: "Liczba dostępnych pokoi z możliwością dodawania",
  },
  {
    mode: "base_prices",
    label: "Ceny bazowe",
    icon: "💰",
    description: "Ceny z Profitroom bez modyfikatorów",
  },
  {
    mode: "final_prices",
    label: "Ceny finalne",
    icon: "🏷️",
    description: "Ceny po zastosowaniu narzutów/rabatów",
  },
];

const ViewModeTabs: React.FC = () => {
  const { viewMode, setViewMode } = useAccommodation();

  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {VIEW_MODES.map((tab) => (
          <button
            key={tab.mode}
            onClick={() => setViewMode(tab.mode)}
            className={`
              group inline-flex items-center gap-2 py-2 px-1 border-b-2 font-medium text-sm transition-colors
              ${
                viewMode === tab.mode
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200"
              }
            `}
          >
            <span className="text-base">{tab.icon}</span>
            <span>{tab.label}</span>

            {/* Tooltip - pokazuje się na hover */}
            <div className="relative">
              <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                {tab.description}
                <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-2 h-2 bg-gray-900 rotate-45"></div>
              </div>
            </div>
          </button>
        ))}
      </nav>
    </div>
  );
};

export default ViewModeTabs;
